<app-center-container
  [title]="title"
  [showClose]="true"
  (close)="close()">

  <br>
    <div>
      {{ 'selectPatientToMerge' | translate }}:
    </div>
    <br>

      @if (form) {
        <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
          <app-input-wrapper
            [control]="form.get('patient')"
            label="{{ 'patient' | translate }}">
            <input
              type="text"
              class="form_control"
              formControlName="patient"
              [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete" class="dropdown dropdown--autocomplete">
                @for (patient of patients$ | async; track patient.id) {
                  <mat-option
                    [value]="patientsService.getDisplayName(patient)"
                    (onSelectionChange)="onSelectPatient(patient)">
                    {{ patientsService.getDisplayName(patient) }}
                  </mat-option>
                }
              </mat-autocomplete>
            </app-input-wrapper>
            <br>
              <button class="button button--primary form_button" type="submit" [disabled]="!form.valid || !form.dirty || !selectedPatient">
                <span class="regular">{{ 'done' | translate }}</span>
              </button>
            </form>
          }

        </app-center-container>

        @if (isLoading) {
          <app-loader></app-loader>
        }
